"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CarouselContent = void 0;
var react_1 = __importStar(require("react"));
var cloneChildren_1 = __importDefault(require("../../helpers/component/cloneChildren"));
var usePropHasChanged_1 = __importDefault(require("../../helpers/hook/usePropHasChanged"));
var mixins_1 = require("../../mixins");
var Container_1 = require("../Container");
var CarouselContext_1 = require("./CarouselContext");
var generateStyles = function (style, orientation, height, hasChanged, duration, nbVisibleItems, isReversing, nbItems) {
    var percent = 1 / nbVisibleItems;
    var translation = "" + (isReversing ? '-' : '') + percent * 100 + "%";
    var contentStyle = __assign(__assign({}, style), { display: 'flex', position: 'relative' });
    var itemStyle = { flex: "1 0 " + percent * 100 + "%" };
    if (orientation === 'vertical') {
        contentStyle = __assign(__assign({}, contentStyle), { flexDirection: 'column', top: "calc(-" + height + " * " + percent + ")", height: height, transform: "translateY(" + translation + ")" });
        itemStyle = __assign(__assign({}, itemStyle), { height: "calc(" + height + " * " + percent + ")" });
    }
    else {
        contentStyle = __assign(__assign({}, contentStyle), { left: nbItems > 1 ? "-" + percent * 100 + "%" : 0, transform: "translateX(" + translation + ")" });
    }
    if (!hasChanged) {
        contentStyle = __assign(__assign({}, contentStyle), { transform: 'none', transition: "transform " + duration + "ms cubic-bezier(0.23, 1, 0.32, 1)" });
    }
    return { contentStyle: contentStyle, itemStyle: itemStyle };
};
var SwipeableContainer = mixins_1.swipeable(Container_1.Container);
var CarouselContent = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, height = _a.height, _c = _a.duration, duration = _c === void 0 ? 500 : _c, style = _a.style, rest = __rest(_a, ["className", "children", "orientation", "height", "duration", "style"]);
    var _d = CarouselContext_1.useCarouselContext(), length = _d.length, index = _d.index, setLength = _d.setLength, isReversing = _d.isReversing, nbVisibleItems = _d.nbVisibleItems, next = _d.next, previous = _d.previous;
    var hasChanged = usePropHasChanged_1["default"](index);
    var _e = react_1.useMemo(function () {
        return generateStyles(style || {}, orientation, height, hasChanged, duration, nbVisibleItems, isReversing, length);
    }, [
        style,
        isReversing,
        orientation,
        hasChanged,
        duration,
        nbVisibleItems,
        height,
        length,
    ]), contentStyle = _e.contentStyle, itemStyle = _e.itemStyle;
    var _f = react_1.useMemo(function () {
        return cloneChildren_1["default"](function (idx, _a) {
            var style = _a.style;
            return ({
                childIndex: idx,
                style: __assign(__assign(__assign({}, style), itemStyle), { order: length ? (idx + length - index + 1) % length : 1 })
            });
        }, children);
    }, [length, children, index, JSON.stringify(itemStyle)]), count = _f.count, clonedChildren = _f.clonedChildren;
    react_1.useEffect(function () {
        setLength && setLength(count);
    }, [count, setLength]);
    var onSwipeFunctions = orientation === 'horizontal'
        ? {
            onSwipeLeft: next,
            onSwipeRight: previous
        }
        : {};
    return (react_1["default"].createElement(SwipeableContainer, __assign({ className: ['carousel_content', className], style: __assign(__assign({}, style), { overflow: 'hidden' }) }, onSwipeFunctions, rest),
        react_1["default"].createElement(Container_1.Container, { style: contentStyle }, clonedChildren)));
};
exports.CarouselContent = CarouselContent;
//# sourceMappingURL=CarouselContent.js.map